export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Int64: { input: any; output: any; }
  Map: { input: any; output: any; }
  Time: { input: any; output: any; }
  UUID: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export enum AcceptOrderMode {
  Accept = 'ACCEPT',
  EnquireOnly = 'ENQUIRE_ONLY'
}

export enum Active {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Internal = 'INTERNAL'
}

export type Address = {
  __typename?: 'Address';
  addressDistrict?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLocality?: Maybe<Scalars['String']['output']>;
  addressPostcode?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<LatLong>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  owner: User;
  ownerId: Scalars['UUID']['output'];
};

export type AddressInput = {
  addressDistrict?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressLocality?: InputMaybe<Scalars['String']['input']>;
  addressPostcode?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<LatLongInput>;
};

export type AmicAddress = {
  __typename?: 'AmicAddress';
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type AmicCustomerData = {
  __typename?: 'AmicCustomerData';
  address?: Maybe<AmicAddress>;
  billingProcess?: Maybe<Scalars['String']['output']>;
  customerGroupName?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<AmicFullAddress>;
  deliveryAddresses?: Maybe<Array<Maybe<AmicFullAddress>>>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mainAddress?: Maybe<AmicFullAddress>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  taxGroupName?: Maybe<Scalars['String']['output']>;
};

export type AmicFullAddress = {
  __typename?: 'AmicFullAddress';
  country?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type AmicInventoryData = {
  __typename?: 'AmicInventoryData';
  articleID?: Maybe<Scalars['Int']['output']>;
  articleNo?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eanCode?: Maybe<Scalars['String']['output']>;
  isWebArticle?: Maybe<Scalars['Boolean']['output']>;
  itemWeight?: Maybe<Scalars['Float']['output']>;
  matrix?: Maybe<Scalars['Map']['output']>;
  prices?: Maybe<Array<Maybe<AmicInventoryDataPrice>>>;
  taxCode?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AmicInventoryDataPrice = {
  __typename?: 'AmicInventoryDataPrice';
  price?: Maybe<Scalars['Float']['output']>;
  priceAmount?: Maybe<Scalars['Float']['output']>;
  priceListID?: Maybe<Scalars['String']['output']>;
  priceUnit?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['String']['output']>;
  validTo?: Maybe<Scalars['String']['output']>;
};

export enum AnalyticsType {
  CustomerSales = 'CUSTOMER_SALES',
  OrderDecline = 'ORDER_DECLINE',
  OrderNotification = 'ORDER_NOTIFICATION',
  SalesComparison = 'SALES_COMPARISON'
}

export type Article = {
  __typename?: 'Article';
  amount?: Maybe<Scalars['Float']['output']>;
  comparisonAmount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  customAmount?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eanCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  inventory: Array<InventoryData>;
  keywords: Array<Scalars['String']['output']>;
  loose?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  package?: Maybe<Scalars['String']['output']>;
  quantityOptions?: Maybe<QuantityOptions>;
  rank?: Maybe<Scalars['Float']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  taxonomy: Taxonomy;
  taxonomyId: Scalars['ID']['output'];
  uid?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type ArticleEdge = {
  __typename?: 'ArticleEdge';
  cursor: Scalars['ID']['output'];
  nextCursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<Article>;
};

export type ArticleSearchInput = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  taxonomyId?: InputMaybe<Scalars['ID']['input']>;
};

export type ArticlesConnection = {
  __typename?: 'ArticlesConnection';
  edges: Array<ArticleEdge>;
  pageInfo: PageInfo;
};

export type Attachment = {
  __typename?: 'Attachment';
  data: Scalars['String']['output'];
  type: AttachmentType;
};

export type AttachmentInput = {
  data: Scalars['String']['input'];
  type: AttachmentType;
};

export enum AttachmentType {
  File = 'FILE',
  Orderid = 'ORDERID',
  Url = 'URL'
}

export type Blob = {
  __typename?: 'Blob';
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
};

export enum CheckFlow {
  PassAll = 'PASS_ALL',
  PassOne = 'PASS_ONE'
}

export type ComparisonDateFilter = {
  month: Scalars['Int64']['input'];
  year: Scalars['Int64']['input'];
};

export type Contract = {
  __typename?: 'Contract';
  attachment?: Maybe<ContractAttachment>;
  attachmentID?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  customer: Customer;
  customerID: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  erpID?: Maybe<Scalars['String']['output']>;
  expectedDeliveryAt: TimeFrame;
  harvestYear?: Maybe<Scalars['Int64']['output']>;
  id: Scalars['ID']['output'];
  lineItems: Array<ContractLineItem>;
  parityDeliveryMethod?: Maybe<Scalars['String']['output']>;
  paymentTerms: Scalars['String']['output'];
  priceDetails?: Maybe<Scalars['String']['output']>;
  retailer: Retailer;
  retailerID: Scalars['ID']['output'];
  status: ContractStatus;
  storageLocationID?: Maybe<Scalars['ID']['output']>;
  type: ContractType;
  updatedAt: Scalars['String']['output'];
  updatedBy?: Maybe<User>;
  updatedByID?: Maybe<Scalars['UUID']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ContractAttachment = {
  __typename?: 'ContractAttachment';
  createdAt: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  key: Scalars['String']['output'];
  mime: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type ContractConnection = {
  __typename?: 'ContractConnection';
  edges: Array<ContractEdge>;
  pageInfo: PageInfo;
};

export type ContractEdge = {
  __typename?: 'ContractEdge';
  cursor: Scalars['ID']['output'];
  nextCursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<Contract>;
};

export type ContractFilterInput = {
  contractStatus?: InputMaybe<Array<ContractStatus>>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  expectedDeliveryEndAt?: InputMaybe<OperatorInput>;
  expectedDeliveryStartAt?: InputMaybe<OperatorInput>;
  harvestYear?: InputMaybe<OperatorNumberInput>;
  parityDeliveryMethod?: InputMaybe<Scalars['String']['input']>;
  retailer?: InputMaybe<Scalars['ID']['input']>;
};

export type ContractInput = {
  amount: Scalars['Float']['input'];
  articles: Array<Scalars['ID']['input']>;
  buyPrice: Scalars['Float']['input'];
  contractTemplate?: InputMaybe<ContractTemplate>;
  expectedDeliveryAt: TimeFrameInput;
  harvestYear?: InputMaybe<Scalars['Int64']['input']>;
  parityDeliveryMethod: Scalars['String']['input'];
  payment?: InputMaybe<Scalars['String']['input']>;
  paymentTerms: Scalars['String']['input'];
  priceDetails?: InputMaybe<Scalars['String']['input']>;
  qualityMeasures?: InputMaybe<Scalars['String']['input']>;
  sellPrice: Scalars['Float']['input'];
  storageLocationID?: InputMaybe<Scalars['ID']['input']>;
  type: ContractType;
};

export type ContractLineItem = {
  __typename?: 'ContractLineItem';
  amount: Scalars['Float']['output'];
  article?: Maybe<Article>;
  articleID?: Maybe<Scalars['ID']['output']>;
  buyPrice?: Maybe<Scalars['Float']['output']>;
  contractID: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  deliveredAmount: Scalars['Float']['output'];
  erpAmountUnit: Scalars['String']['output'];
  erpArticleID?: Maybe<Scalars['String']['output']>;
  erpArticleName: Scalars['String']['output'];
  erpPriceAmount: Scalars['Float']['output'];
  erpPriceUnit: Scalars['String']['output'];
  qualityMeasures?: Maybe<Scalars['String']['output']>;
  sellPrice?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type ContractSortInput = {
  expectedDeliveryEndAt?: InputMaybe<Sort>;
  expectedDeliveryStartAt?: InputMaybe<Sort>;
  harvestYear?: InputMaybe<Sort>;
};

export enum ContractStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Draft = 'DRAFT',
  Fullfilled = 'FULLFILLED',
  PartiallyFulfilled = 'PARTIALLY_FULFILLED'
}

export enum ContractTemplate {
  Brotroggen = 'BROTROGGEN',
  Dinkel = 'DINKEL',
  Durum = 'DURUM',
  Erbsen = 'ERBSEN',
  Futterroggen = 'FUTTERROGGEN',
  Futterweizen = 'FUTTERWEIZEN',
  Hafer = 'HAFER',
  Mais = 'MAIS',
  Raps = 'RAPS',
  Sojabohne = 'SOJABOHNE',
  Sommerbraugerste = 'SOMMERBRAUGERSTE',
  Sommergerste = 'SOMMERGERSTE',
  Sonnenblumen = 'SONNENBLUMEN',
  Triticale = 'TRITICALE',
  Weizen = 'WEIZEN',
  Winterbraugerste = 'WINTERBRAUGERSTE',
  Wintergerste = 'WINTERGERSTE'
}

export enum ContractType {
  Purchase = 'PURCHASE',
  Sale = 'SALE',
  Unknown = 'UNKNOWN'
}

export type Coordinates = {
  __typename?: 'Coordinates';
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
};

export type CreateContractOptions = {
  notificationMessage?: InputMaybe<Scalars['String']['input']>;
};

export type CreditNote = {
  __typename?: 'CreditNote';
  createdAt: Scalars['String']['output'];
  customer?: Maybe<Customer>;
  customerID: Scalars['ID']['output'];
  document?: Maybe<Document>;
  documentID: Scalars['ID']['output'];
  erpCustomerID?: Maybe<Scalars['String']['output']>;
  erpID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lineItems: Array<CreditNoteLineItem>;
  retailer?: Maybe<Retailer>;
  retailerID: Scalars['ID']['output'];
  status: NoteStatus;
  taxRate: Scalars['Float']['output'];
  totalGross: Scalars['Float']['output'];
  totalNet: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
  user?: Maybe<User>;
  userID?: Maybe<Scalars['UUID']['output']>;
};

export type CreditNoteEdge = {
  __typename?: 'CreditNoteEdge';
  cursor: Scalars['ID']['output'];
  nextCursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<CreditNote>;
};

export type CreditNoteLineItem = {
  __typename?: 'CreditNoteLineItem';
  createdAt: Scalars['String']['output'];
  creditNoteID: Scalars['ID']['output'];
  erpID?: Maybe<Scalars['String']['output']>;
  erpItemID?: Maybe<Scalars['String']['output']>;
  erpOrderID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  item?: Maybe<Inventory>;
  itemID: Scalars['ID']['output'];
  lineQuantityUnit: Scalars['String']['output'];
  lineTotalGross: Scalars['Float']['output'];
  lineTotalNet: Scalars['Float']['output'];
  lineTotalQuantity: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Order>;
  orderID: Scalars['ID']['output'];
  taxRate: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
};

export type CreditNotesConnection = {
  __typename?: 'CreditNotesConnection';
  edges: Array<CreditNoteEdge>;
  pageInfo: PageInfo;
};

export type CreditNotesFilterInput = {
  customerID?: InputMaybe<Scalars['ID']['input']>;
  retailerID?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreditNotesSortInput = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type CropDeliveryNote = {
  __typename?: 'CropDeliveryNote';
  articleName?: Maybe<Scalars['String']['output']>;
  articleNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  customerID?: Maybe<Scalars['ID']['output']>;
  deliveryAddress?: Maybe<OrderAddress>;
  deliveryDate: Scalars['String']['output'];
  erpCustomerID: Scalars['String']['output'];
  erpDeliveryID: Scalars['String']['output'];
  erpItemID: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inventoryID?: Maybe<Scalars['ID']['output']>;
  qualities: Array<CropDeliveryNoteQuality>;
  quantity: Scalars['Float']['output'];
  quantityUnit: Scalars['String']['output'];
  retailerID: Scalars['ID']['output'];
  status: NoteStatus;
  updatedAt: Scalars['String']['output'];
  userID?: Maybe<Scalars['UUID']['output']>;
};

export type CropDeliveryNoteEdge = {
  __typename?: 'CropDeliveryNoteEdge';
  cursor: Scalars['ID']['output'];
  nextCursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<CropDeliveryNote>;
};

export type CropDeliveryNoteFilterInput = {
  customerID?: InputMaybe<Scalars['ID']['input']>;
  deliveryDate?: InputMaybe<Array<OperatorInput>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  retailerID?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CropDeliveryNoteQuality = {
  __typename?: 'CropDeliveryNoteQuality';
  title?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CropDeliveryNotesConnection = {
  __typename?: 'CropDeliveryNotesConnection';
  edges: Array<CropDeliveryNoteEdge>;
  pageInfo: PageInfo;
};

export type CropDeliveryNotesSortInput = {
  deliveryDate?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export enum Currency {
  Eur = 'EUR'
}

export type Customer = {
  __typename?: 'Customer';
  code: Scalars['String']['output'];
  contract: Contract;
  contractsConnection: ContractConnection;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  documents: Array<Document>;
  erpCustomerGroupID?: Maybe<Scalars['String']['output']>;
  erpCustomerID?: Maybe<Scalars['String']['output']>;
  erpData?: Maybe<ErpCustomerData>;
  erpEmailAddress?: Maybe<Scalars['String']['output']>;
  erpPhoneNumber?: Maybe<Scalars['String']['output']>;
  groups: Array<CustomerGroup>;
  id: Scalars['ID']['output'];
  invoices: Array<Maybe<Invoice>>;
  isIndirect: Scalars['Boolean']['output'];
  lineItemsConnection: OrderLinesConnection;
  notes: Array<CustomerNote>;
  notifications?: Maybe<Array<Notification>>;
  orders: Array<Order>;
  ordersConnection: OrdersConnection;
  prices?: Maybe<Array<CustomerPrice>>;
  qrCode: Scalars['String']['output'];
  rank?: Maybe<Scalars['Float']['output']>;
  retailer: Retailer;
  retailerID: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
  user?: Maybe<User>;
  userID?: Maybe<Scalars['UUID']['output']>;
};


export type CustomerContractArgs = {
  id: Scalars['ID']['input'];
};


export type CustomerContractsConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<ContractFilterInput>;
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<ContractSortInput>;
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type CustomerDocumentsArgs = {
  filter?: InputMaybe<DocumentFilterInput>;
};


export type CustomerLineItemsConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<OrderLineFilterInput>;
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<LineItemSortInput>;
  timeFilter?: InputMaybe<Array<InputMaybe<TimeFilterInput>>>;
};


export type CustomerNotesArgs = {
  filter?: InputMaybe<CustomerNoteFilter>;
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type CustomerNotificationsArgs = {
  retailerId: Scalars['ID']['input'];
  sort?: InputMaybe<NotificationSortInput>;
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type CustomerOrdersArgs = {
  filter?: InputMaybe<OrderFilterInput>;
};


export type CustomerOrdersConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<OrderFilterInput>;
  first?: Scalars['Int']['input'];
  timeFilter?: InputMaybe<Array<InputMaybe<TimeFilterInput>>>;
};

export type CustomerArticle = {
  __typename?: 'CustomerArticle';
  customerId: Scalars['ID']['output'];
  erpCustomerId: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  taxonomyId: Scalars['ID']['output'];
  taxonomyName: Scalars['String']['output'];
};

export type CustomerEdge = {
  __typename?: 'CustomerEdge';
  cursor: Scalars['ID']['output'];
  nextCursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<Customer>;
};

export type CustomerFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerGroup = {
  __typename?: 'CustomerGroup';
  erpManaged: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CustomerInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  retailerCustomerID?: InputMaybe<Scalars['String']['input']>;
  retailerEmailAddress?: InputMaybe<Scalars['String']['input']>;
  retailerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerNote = {
  __typename?: 'CustomerNote';
  attachments: Array<Attachment>;
  author?: Maybe<User>;
  authorID?: Maybe<Scalars['UUID']['output']>;
  authoredAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  customer: Customer;
  customerID: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  editedAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  operator?: Maybe<Operator>;
  operatorID?: Maybe<Scalars['ID']['output']>;
  retailer: Retailer;
  retailerID: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CustomerNoteFilter = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerNoteInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  text: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerPrice = {
  __typename?: 'CustomerPrice';
  ErpCustomerGroupID?: Maybe<Scalars['String']['output']>;
  articleDescription1?: Maybe<Scalars['String']['output']>;
  articleDescription2?: Maybe<Scalars['String']['output']>;
  articleID?: Maybe<Scalars['Int64']['output']>;
  createdAt: Scalars['String']['output'];
  customerID: Scalars['Int64']['output'];
  date: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountAllowed: Scalars['Boolean']['output'];
  erpArticleID: Scalars['String']['output'];
  erpCustomerID?: Maybe<Scalars['String']['output']>;
  foreignCurrency?: Maybe<Scalars['String']['output']>;
  freight?: Maybe<Scalars['Float']['output']>;
  grossAmount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  minQuantity?: Maybe<Scalars['Int64']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceIncludingFreight: Scalars['Float']['output'];
  retailerID: Scalars['Int64']['output'];
  specialFreight?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  validFrom: Scalars['String']['output'];
  validUntil?: Maybe<Scalars['String']['output']>;
  vatRate: Scalars['Int64']['output'];
};

export type CustomerSales = {
  __typename?: 'CustomerSales';
  articleId: Scalars['ID']['output'];
  articleName: Scalars['String']['output'];
  customerFamilyName: Scalars['String']['output'];
  customerGivenName?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  erpCustomerId: Scalars['String']['output'];
  invoiceDate: Scalars['String']['output'];
  lineTotalNet: Scalars['Float']['output'];
  lineTotalQuantity: Scalars['Float']['output'];
  retailerId: Scalars['ID']['output'];
  taxonomyId: Scalars['ID']['output'];
  taxonomyName: Scalars['String']['output'];
};

export type CustomerSalesSearchFilter = {
  articleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate: Scalars['String']['input'];
  erpCustomerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['String']['input'];
  taxonomyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CustomersConnection = {
  __typename?: 'CustomersConnection';
  edges: Array<CustomerEdge>;
  pageInfo: PageInfo;
};

export type DatasheetUploadUrlInfo = {
  __typename?: 'DatasheetUploadUrlInfo';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type DateFilterInput = {
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Delivery = {
  __typename?: 'Delivery';
  address?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<OrderAddress>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  deliveryFrom?: Maybe<Scalars['String']['output']>;
  deliveryReference?: Maybe<Scalars['String']['output']>;
  deliveryTo?: Maybe<Scalars['String']['output']>;
  estimatedDeliveryDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  locationID?: Maybe<Scalars['ID']['output']>;
  order?: Maybe<Order>;
  orderID: Scalars['ID']['output'];
  retailerDeliveryID?: Maybe<Scalars['String']['output']>;
  siloID?: Maybe<Scalars['ID']['output']>;
  siloName?: Maybe<Scalars['String']['output']>;
  status: DeliveryStatus;
  type: DeliveryType;
  updatedAt: Scalars['String']['output'];
};

export type DeliveryFilterInput = {
  confirmedAt?: InputMaybe<Array<OperatorInput>>;
};

export enum DeliveryStatus {
  Complete = 'COMPLETE',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  Pending = 'PENDING',
  Scheduled = 'SCHEDULED'
}

export enum DeliveryType {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP',
  Postal = 'POSTAL',
  Unknown = 'UNKNOWN'
}

export enum DiscoverabilityMode {
  Discoverable = 'DISCOVERABLE',
  ExistingCustomers = 'EXISTING_CUSTOMERS',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Document = {
  __typename?: 'Document';
  createdAt: Scalars['String']['output'];
  customerID: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Order>;
  orderID?: Maybe<Scalars['ID']['output']>;
  retailerID: Scalars['ID']['output'];
  type: DocumentType;
  updatedAt: Scalars['String']['output'];
  url: Scalars['String']['output'];
  userID?: Maybe<Scalars['UUID']['output']>;
};

export type DocumentEdge = {
  __typename?: 'DocumentEdge';
  cursor: Scalars['ID']['output'];
  nextCursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<Document>;
};

export type DocumentFilterInput = {
  documentType?: InputMaybe<DocumentType>;
};

export enum DocumentType {
  CreditNote = 'CREDIT_NOTE',
  DeliveryNote = 'DELIVERY_NOTE',
  Invoice = 'INVOICE',
  Order = 'ORDER',
  Receipt = 'RECEIPT'
}

export type DocumentsConnection = {
  __typename?: 'DocumentsConnection';
  edges: Array<DocumentEdge>;
  pageInfo: PageInfo;
};

export type ErpCustomerData = AmicCustomerData;

export enum ErpType {
  Serp = 'SERP',
  Vas = 'VAS'
}

export type FindCustomerArticleFilter = {
  customerId?: InputMaybe<Array<Scalars['ID']['input']>>;
  erpCustomerId?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<AnalyticsType>;
};

export type InitSyncJobInput = {
  retailerID: Scalars['ID']['input'];
  userID: Scalars['UUID']['input'];
  version?: Scalars['Int']['input'];
};

export type Inventory = {
  __typename?: 'Inventory';
  active: Active;
  articleData?: Maybe<Article>;
  articleId?: Maybe<Scalars['ID']['output']>;
  availableStockLevel?: Maybe<Scalars['Float']['output']>;
  basePrice?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  deliveryTimeEst?: Maybe<Scalars['Int']['output']>;
  erpData?: Maybe<AmicInventoryData>;
  id: Scalars['ID']['output'];
  inventoryLocations?: Maybe<Array<Maybe<InventoryLocation>>>;
  isDataSheetAvailable?: Maybe<Scalars['Boolean']['output']>;
  leadTimeEst?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Field no longer supported */
  locations: Array<Maybe<Location>>;
  orderLineItemsConnection: OrderLinesConnection;
  orders?: Maybe<Array<Order>>;
  quantityPending?: Maybe<Scalars['Float']['output']>;
  quantityStocked?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  retailerBasePrice?: Maybe<RetailerBasePrice>;
  retailerId?: Maybe<Scalars['ID']['output']>;
  retailerItemId?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['String']['output'];
  visibleForCustomers: Scalars['Boolean']['output'];
  visibleForRepresentatives: Scalars['Boolean']['output'];
  volumeDiscounts?: Maybe<Array<VolumeDiscount>>;
};


export type InventoryLocationsArgs = {
  locationFilter?: InputMaybe<LocationFilter>;
};


export type InventoryOrderLineItemsConnectionArgs = {
  after: Scalars['ID']['input'];
  first?: Scalars['Int']['input'];
};


export type InventoryOrdersArgs = {
  filter?: InputMaybe<OrderFilterInput>;
};


export type InventoryVolumeDiscountsArgs = {
  filter?: InputMaybe<VolumeDiscountFilter>;
};

export type InventoryConnection = {
  __typename?: 'InventoryConnection';
  edges: Array<InventoryEdge>;
  pageInfo: PageInfo;
};

export type InventoryData = {
  __typename?: 'InventoryData';
  active: Active;
  articleId?: Maybe<Scalars['ID']['output']>;
  basePrice?: Maybe<Scalars['Float']['output']>;
  deliveryTimeEst?: Maybe<Scalars['Int']['output']>;
  erpData?: Maybe<AmicInventoryData>;
  id: Scalars['ID']['output'];
  leadTimeEst?: Maybe<Scalars['Int']['output']>;
  locations: Array<InventoryLocationData>;
  quantityOptions?: Maybe<QuantityOptions>;
  quantityPending?: Maybe<Scalars['Float']['output']>;
  quantityStocked?: Maybe<Scalars['Float']['output']>;
  retailerId: Scalars['ID']['output'];
  retailerItemId?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  visibleForCustomers: Scalars['Boolean']['output'];
  visibleForRepresentatives: Scalars['Boolean']['output'];
  volumeDiscounts?: Maybe<Array<VolumeDiscount>>;
};


export type InventoryDataVolumeDiscountsArgs = {
  filter?: InputMaybe<VolumeDiscountFilter>;
};

export type InventoryEdge = {
  __typename?: 'InventoryEdge';
  cursor: Scalars['ID']['output'];
  nextCursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<Inventory>;
};

export type InventoryInput = {
  active?: InputMaybe<Active>;
  availableStockLevel?: InputMaybe<Scalars['Float']['input']>;
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  datasheetKey?: InputMaybe<Scalars['String']['input']>;
  deliveryTimeEst?: InputMaybe<Scalars['Int']['input']>;
  leadTimeEst?: InputMaybe<Scalars['Int']['input']>;
  quantityPending?: InputMaybe<Scalars['Float']['input']>;
  quantityStocked?: InputMaybe<Scalars['Float']['input']>;
  salePrice?: InputMaybe<Scalars['Float']['input']>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  visibleForCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  visibleForRepresentatives?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InventoryLocation = {
  __typename?: 'InventoryLocation';
  availableStockLevel?: Maybe<Scalars['Float']['output']>;
  inventoryID: Scalars['ID']['output'];
  location: Location;
  locationID: Scalars['ID']['output'];
  quantityStocked: Scalars['Float']['output'];
  quantityStockedUnit: Scalars['String']['output'];
  retailerID: Scalars['ID']['output'];
};

export type InventoryLocationData = {
  __typename?: 'InventoryLocationData';
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export type InventorySearch = {
  activeState?: InputMaybe<Scalars['String']['input']>;
  isInStock?: InputMaybe<Scalars['Boolean']['input']>;
  locationStatus: Array<LocationStatus>;
  priceRange?: InputMaybe<Array<Scalars['Float']['input']>>;
  retailerId: Scalars['ID']['input'];
};

export type Invoice = {
  __typename?: 'Invoice';
  createdAt: Scalars['String']['output'];
  customerID: Scalars['ID']['output'];
  document?: Maybe<Document>;
  documentID?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  issuedAt: Scalars['String']['output'];
  lineItems: Array<InvoiceLineItem>;
  paymentID?: Maybe<Scalars['ID']['output']>;
  paymentOptions: Array<PaymentOption>;
  retailerID: Scalars['ID']['output'];
  retailerInvoiceID: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalGross: Scalars['Float']['output'];
  totalNet: Scalars['Float']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  userID?: Maybe<Scalars['UUID']['output']>;
};

export type InvoiceEdge = {
  __typename?: 'InvoiceEdge';
  cursor: Scalars['ID']['output'];
  nextCursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<Invoice>;
};

export type InvoiceLineEdge = {
  __typename?: 'InvoiceLineEdge';
  cursor: Scalars['ID']['output'];
  nextCursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<InvoiceLineItem>;
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  amount: Scalars['Float']['output'];
  catalogueID?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  inventoryID?: Maybe<Scalars['ID']['output']>;
  invoiceID: Scalars['ID']['output'];
  itemPrice: Scalars['Float']['output'];
  itemQuantity: Scalars['Float']['output'];
  itemUnit: Scalars['String']['output'];
  lineRate: Scalars['Float']['output'];
  lineTotalNet: Scalars['Float']['output'];
  lineTotalQuantity: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  retailerID: Scalars['ID']['output'];
  retailerItemID: Scalars['ID']['output'];
  taxRate: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
};

export type InvoiceLinesConnection = {
  __typename?: 'InvoiceLinesConnection';
  edges: Array<InvoiceLineEdge>;
  pageInfo: PageInfo;
};

export type InvoicesConnection = {
  __typename?: 'InvoicesConnection';
  edges: Array<InvoiceEdge>;
  pageInfo: PageInfo;
};

export type InvoicesConnectionInput = {
  retailerID?: InputMaybe<Scalars['ID']['input']>;
};

export type InvoicesConnectionSortInput = {
  issuedAt?: InputMaybe<Sort>;
};

export type Job = {
  __typename?: 'Job';
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  queue: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type JobConnection = {
  __typename?: 'JobConnection';
  edges: Array<JobEdge>;
  pageInfo: PageInfo;
};

export type JobEdge = {
  __typename?: 'JobEdge';
  cursor: Scalars['ID']['output'];
  nextCursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<Job>;
};

export type JobFilterInput = {
  kind?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<MetadataFilterInput>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type JobSortInput = {
  kind?: InputMaybe<Sort>;
};

export type LatLong = {
  __typename?: 'LatLong';
  lat: Scalars['Float']['output'];
  long: Scalars['Float']['output'];
};

export type LatLongInput = {
  lat: Scalars['Float']['input'];
  long: Scalars['Float']['input'];
};

export type LineItemSortInput = {
  confirmedAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type LivePrice = {
  __typename?: 'LivePrice';
  erpArticleId: Scalars['String']['output'];
  inventoryId: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
};

export type LivePriceInput = {
  erpCustomerGroupId?: InputMaybe<Scalars['String']['input']>;
  erpCustomerId: Scalars['String']['input'];
  erpType: ErpType;
  inventories: Array<LivePriceInventoriesInput>;
  retailerId: Scalars['ID']['input'];
};

export type LivePriceInventoriesInput = {
  erpArticleId: Scalars['String']['input'];
  inventoryId: Scalars['ID']['input'];
};

export type Location = {
  __typename?: 'Location';
  erpStorageLocationID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locationStatus: LocationStatus;
  name: Scalars['String']['output'];
};

export type LocationFilter = {
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  locationIDs?: InputMaybe<Array<Scalars['Int64']['input']>>;
  status: Array<LocationStatus>;
};

export type LocationInput = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

export enum LocationStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type MetadataFilterInput = {
  retailerID?: InputMaybe<Scalars['ID']['input']>;
};

export type MetricJobInput = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type MollieAddress = {
  __typename?: 'MollieAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  streetAndNumber: Scalars['String']['output'];
};

export type MollieConfig = {
  __typename?: 'MollieConfig';
  clientId: Scalars['String']['output'];
  redirectUrl: Scalars['String']['output'];
  scopes: Scalars['String']['output'];
  testmode: Scalars['Boolean']['output'];
  urls: MollieUrls;
};

export type MollieOrganization = {
  __typename?: 'MollieOrganization';
  address: MollieAddress;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paymentMethods: Array<Scalars['String']['output']>;
  registrationNumber: Scalars['String']['output'];
  resource: Scalars['String']['output'];
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatRegulation?: Maybe<Scalars['String']['output']>;
};

export enum MolliePaymentStatus {
  Authorized = 'authorized',
  Canceled = 'canceled',
  Expired = 'expired',
  Failed = 'failed',
  Open = 'open',
  Paid = 'paid',
  Pending = 'pending'
}

export type MollieUrls = {
  __typename?: 'MollieUrls';
  accessTokenUrl: Scalars['String']['output'];
  authorizationUrl: Scalars['String']['output'];
  resourceOwnerUrl: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addCustomerNotificationGroupMessage: Scalars['Boolean']['output'];
  addRetailerUser: Scalars['Boolean']['output'];
  assignRetailerUserRole?: Maybe<Scalars['Boolean']['output']>;
  attachSalesNoteSignature: Scalars['Boolean']['output'];
  checkoutOrder: Order;
  createAttachmentUploadUrls: Array<NotificationAttachmentUploadUrlInfo>;
  createContract: Contract;
  createCustomer: Customer;
  createCustomerNote: CustomerNote;
  createInitSyncJob: Job;
  createMetricJob: Job;
  createNotificationGroup: Scalars['Boolean']['output'];
  createNotifications: Array<Notification>;
  createOrder: Order;
  createPaymentForInvoice?: Maybe<PaymentInvoice>;
  createRetailerNote: Scalars['Boolean']['output'];
  createRetailerUploadUrls: Array<UploadUrlInfo>;
  createServiceErpRetailersSyncJob: Job;
  createServiceErpSyncJob: Job;
  createSilo: Silo;
  createUser: User;
  createUserAddress: Address;
  deleteCustomer: Scalars['Boolean']['output'];
  deleteCustomerNote: Scalars['Boolean']['output'];
  deleteInvoice: Scalars['Boolean']['output'];
  deleteNotification: Scalars['Boolean']['output'];
  deleteNotificationGroup: Scalars['Boolean']['output'];
  deleteOrder: Scalars['Boolean']['output'];
  deleteSilo: Scalars['Boolean']['output'];
  generateInventoryDatasheetURL: DatasheetUploadUrlInfo;
  joinRetailer?: Maybe<Customer>;
  leaveRetailer: Scalars['Boolean']['output'];
  payOrderById: Order;
  readNotification: Notification;
  removeCustomerNotificationGroupMessage: Scalars['Boolean']['output'];
  removeInventoryBy?: Maybe<Scalars['Void']['output']>;
  removeRetailerUserRoleOperator: Scalars['Boolean']['output'];
  resolveNotification: Notification;
  sendDeliveryPdf: Scalars['Boolean']['output'];
  sendNotificationGroupMessage: Scalars['Boolean']['output'];
  setRetailerUserRoleOperator: Scalars['Boolean']['output'];
  setUserToken?: Maybe<Scalars['Boolean']['output']>;
  storeSession: UserSession;
  submitMollieCode: Scalars['Boolean']['output'];
  unAssignRetailerUserRole?: Maybe<Scalars['Boolean']['output']>;
  unsetUserToken?: Maybe<Scalars['Boolean']['output']>;
  updateContract: Contract;
  updateContractStatus: Contract;
  updateCustomerNote: CustomerNote;
  updateInventoryArticle: Inventory;
  updateInventoryItem: Inventory;
  updateLocation: Location;
  updateLocationStatus?: Maybe<Location>;
  updateRetailerPolicy: Retailer;
  updateRetailerSettings: Scalars['Boolean']['output'];
  updateSilo: Silo;
  updateUser: User;
  updateUserAddress: Address;
  updateUserPrimaryAddress: Address;
};


export type MutationAddCustomerNotificationGroupMessageArgs = {
  customerIDs: Array<Scalars['ID']['input']>;
  groupID: Scalars['ID']['input'];
  retailerID: Scalars['ID']['input'];
};


export type MutationAddRetailerUserArgs = {
  email: Scalars['String']['input'];
  retailerId: Scalars['ID']['input'];
  role: RetailerRole;
};


export type MutationAssignRetailerUserRoleArgs = {
  contractNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  retailerId: Scalars['ID']['input'];
  role: RetailerRole;
  userID: Scalars['UUID']['input'];
};


export type MutationAttachSalesNoteSignatureArgs = {
  key: Scalars['String']['input'];
  retailerId: Scalars['ID']['input'];
  salesNoteID: Scalars['ID']['input'];
};


export type MutationCheckoutOrderArgs = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  orderData: OrderDataInput;
  retailerId: Scalars['ID']['input'];
  useDefaultPrice?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateAttachmentUploadUrlsArgs = {
  filenames: Array<Scalars['String']['input']>;
};


export type MutationCreateContractArgs = {
  contract?: InputMaybe<ContractInput>;
  customerID: Scalars['ID']['input'];
  options?: InputMaybe<CreateContractOptions>;
  retailerID: Scalars['ID']['input'];
};


export type MutationCreateCustomerArgs = {
  customerInput: CustomerInput;
  retailerId: Scalars['ID']['input'];
};


export type MutationCreateCustomerNoteArgs = {
  customerId: Scalars['ID']['input'];
  note: CustomerNoteInput;
  retailerId: Scalars['ID']['input'];
};


export type MutationCreateInitSyncJobArgs = {
  job: InitSyncJobInput;
};


export type MutationCreateMetricJobArgs = {
  job?: InputMaybe<MetricJobInput>;
};


export type MutationCreateNotificationGroupArgs = {
  notificationGroupInput: NotificationGroupInput;
  retailerID: Scalars['ID']['input'];
};


export type MutationCreateNotificationsArgs = {
  notification: NotificationInput;
  users: Array<Scalars['UUID']['input']>;
};


export type MutationCreateOrderArgs = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  orderData: OrderDataInput;
  retailerId: Scalars['ID']['input'];
  useDefaultPrice?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreatePaymentForInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
  paymentOptionKey: Scalars['ID']['input'];
};


export type MutationCreateRetailerNoteArgs = {
  extraRecipients?: InputMaybe<Array<Scalars['UUID']['input']>>;
  note: RetailerNoteInput;
  retailerId: Scalars['ID']['input'];
};


export type MutationCreateRetailerUploadUrlsArgs = {
  filenames: Array<Scalars['String']['input']>;
  prefix: UploadPrefix;
};


export type MutationCreateServiceErpSyncJobArgs = {
  job: ServiceErpSyncJobInput;
};


export type MutationCreateSiloArgs = {
  silo: SiloCreateInput;
};


export type MutationCreateUserArgs = {
  simpleWelcome?: Scalars['Boolean']['input'];
  user: UserCreateInput;
};


export type MutationCreateUserAddressArgs = {
  address: AddressInput;
  useAsPrimary?: Scalars['Boolean']['input'];
};


export type MutationDeleteCustomerArgs = {
  customerId: Scalars['ID']['input'];
  retailerId: Scalars['ID']['input'];
};


export type MutationDeleteCustomerNoteArgs = {
  noteId: Scalars['ID']['input'];
  retailerId: Scalars['ID']['input'];
};


export type MutationDeleteInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
  retailerId: Scalars['ID']['input'];
};


export type MutationDeleteNotificationArgs = {
  id: Scalars['ID']['input'];
  retailerId: Scalars['ID']['input'];
};


export type MutationDeleteNotificationGroupArgs = {
  groupID: Scalars['ID']['input'];
  retailerID: Scalars['ID']['input'];
};


export type MutationDeleteOrderArgs = {
  orderId: Scalars['ID']['input'];
  retailerId: Scalars['ID']['input'];
};


export type MutationDeleteSiloArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateInventoryDatasheetUrlArgs = {
  filename: Scalars['String']['input'];
  inventoryID: Scalars['ID']['input'];
  retailerID: Scalars['ID']['input'];
};


export type MutationJoinRetailerArgs = {
  customerCode?: InputMaybe<Scalars['String']['input']>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  inquiryText?: InputMaybe<Scalars['String']['input']>;
  retailerId: Scalars['ID']['input'];
};


export type MutationLeaveRetailerArgs = {
  retailerId: Scalars['ID']['input'];
};


export type MutationPayOrderByIdArgs = {
  customerId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
  retailerId: Scalars['ID']['input'];
};


export type MutationReadNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveCustomerNotificationGroupMessageArgs = {
  customerIDs: Array<Scalars['ID']['input']>;
  groupID: Scalars['ID']['input'];
  retailerID: Scalars['ID']['input'];
};


export type MutationRemoveInventoryByArgs = {
  removeByFilter: RemoveInventoriesByFilter;
};


export type MutationRemoveRetailerUserRoleOperatorArgs = {
  retailerID: Scalars['ID']['input'];
  userID: Scalars['UUID']['input'];
};


export type MutationResolveNotificationArgs = {
  id: Scalars['ID']['input'];
  response: NotificationResolveInput;
};


export type MutationSendDeliveryPdfArgs = {
  orderId: Scalars['ID']['input'];
  retailerId: Scalars['ID']['input'];
};


export type MutationSendNotificationGroupMessageArgs = {
  groupIDs: Array<Scalars['ID']['input']>;
  notificationGroupMessageInput: NotificationGroupMessageInput;
  retailerID: Scalars['ID']['input'];
};


export type MutationSetRetailerUserRoleOperatorArgs = {
  operatorID: Scalars['ID']['input'];
  retailerID: Scalars['ID']['input'];
  userID: Scalars['UUID']['input'];
};


export type MutationSetUserTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationStoreSessionArgs = {
  input: UserSessionInput;
};


export type MutationSubmitMollieCodeArgs = {
  code: Scalars['String']['input'];
  retailerId: Scalars['ID']['input'];
};


export type MutationUnAssignRetailerUserRoleArgs = {
  retailerId: Scalars['ID']['input'];
  userID: Scalars['UUID']['input'];
};


export type MutationUnsetUserTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationUpdateContractArgs = {
  contract?: InputMaybe<ContractInput>;
  id: Scalars['ID']['input'];
  options?: InputMaybe<CreateContractOptions>;
};


export type MutationUpdateContractStatusArgs = {
  id: Scalars['ID']['input'];
  status: ContractStatus;
};


export type MutationUpdateCustomerNoteArgs = {
  note: CustomerNoteInput;
  noteId: Scalars['ID']['input'];
};


export type MutationUpdateInventoryArticleArgs = {
  articleID?: InputMaybe<Scalars['ID']['input']>;
  inventoryID: Scalars['ID']['input'];
};


export type MutationUpdateInventoryItemArgs = {
  inventoryID: Scalars['ID']['input'];
  inventoryInput: InventoryInput;
};


export type MutationUpdateLocationArgs = {
  locationID: Scalars['ID']['input'];
  locationInput: LocationInput;
};


export type MutationUpdateLocationStatusArgs = {
  locationID: Scalars['ID']['input'];
  status: LocationStatus;
};


export type MutationUpdateRetailerPolicyArgs = {
  policyInput: PolicyInput;
  retailerId: Scalars['ID']['input'];
};


export type MutationUpdateRetailerSettingsArgs = {
  retailerId: Scalars['ID']['input'];
  settings: RetailerSettingsInput;
};


export type MutationUpdateSiloArgs = {
  id: Scalars['ID']['input'];
  silo: SiloUpdateInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['UUID']['input'];
  user: UserUpdateInput;
};


export type MutationUpdateUserAddressArgs = {
  address: AddressInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUserPrimaryAddressArgs = {
  id: Scalars['ID']['input'];
};

export type NewPayment = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
  retailerId: Scalars['ID']['input'];
};

export enum NoteStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT'
}

export type Notification = {
  __typename?: 'Notification';
  attachments?: Maybe<Array<NotificationAttachment>>;
  createdAt: Scalars['String']['output'];
  createdBy: User;
  createdByID: Scalars['UUID']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  payload?: Maybe<Scalars['Map']['output']>;
  readAt?: Maybe<Scalars['String']['output']>;
  responseStatus: NotificationResponseStatus;
  retailer: Retailer;
  retailerID: Scalars['ID']['output'];
  subject: Scalars['String']['output'];
  type: NotificationType;
  updatedAt: Scalars['String']['output'];
  user: User;
  userID: Scalars['UUID']['output'];
};

export type NotificationAttachment = {
  __typename?: 'NotificationAttachment';
  createdAt: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  key: Scalars['String']['output'];
  mime: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type NotificationAttachmentInput = {
  filename: Scalars['String']['input'];
  key: Scalars['String']['input'];
  mime: Scalars['String']['input'];
};

export type NotificationAttachmentUploadUrlInfo = {
  __typename?: 'NotificationAttachmentUploadUrlInfo';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  cursor: Scalars['ID']['output'];
  nextCursor?: Maybe<Scalars['ID']['output']>;
  node: Notification;
};

export type NotificationFilterInput = {
  retailerID: Scalars['ID']['input'];
};

export type NotificationGroup = {
  __typename?: 'NotificationGroup';
  createdAt: Scalars['String']['output'];
  customers: Array<Customer>;
  id: Scalars['ID']['output'];
  membersStats: NotificationGroupMembersStats;
  messages: Array<Maybe<NotificationGroupMessage>>;
  retailerID: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};


export type NotificationGroupCustomersArgs = {
  filter?: InputMaybe<NotificationGroupCustomerFilter>;
};

export type NotificationGroupCustomerFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationGroupInput = {
  customers: Array<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

export type NotificationGroupMembersStats = {
  __typename?: 'NotificationGroupMembersStats';
  active: Scalars['Int64']['output'];
  inactive: Scalars['Int64']['output'];
  total: Scalars['Int64']['output'];
};

export type NotificationGroupMessage = {
  __typename?: 'NotificationGroupMessage';
  attachments?: Maybe<Array<NotificationGroupMessageAttachment>>;
  createdAt: Scalars['String']['output'];
  date: Scalars['String']['output'];
  groupID: Scalars['Int64']['output'];
  id: Scalars['ID']['output'];
  membersStats: NotificationGroupMembersStats;
  message: Scalars['String']['output'];
  notificationIDs: Array<Scalars['ID']['output']>;
  notifications?: Maybe<Array<NotificationGroupMessageNotification>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};


export type NotificationGroupMessageNotificationsArgs = {
  filter?: InputMaybe<NotificationGroupMessageNotificationFilter>;
};

export type NotificationGroupMessageAttachment = {
  __typename?: 'NotificationGroupMessageAttachment';
  createdAt: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  key: Scalars['String']['output'];
  mime: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type NotificationGroupMessageAttachmentInput = {
  filename: Scalars['String']['input'];
  key: Scalars['String']['input'];
  mime: Scalars['String']['input'];
};

export type NotificationGroupMessageInput = {
  attachments?: InputMaybe<Array<NotificationGroupMessageAttachmentInput>>;
  message: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type NotificationGroupMessageNotification = {
  __typename?: 'NotificationGroupMessageNotification';
  customer: Customer;
  readAt?: Maybe<Scalars['String']['output']>;
  responseStatus: NotificationGroupMessageNotificationStatus;
};

export type NotificationGroupMessageNotificationFilter = {
  responseStatus: NotificationGroupMessageNotificationStatus;
};

export enum NotificationGroupMessageNotificationStatus {
  Accept = 'ACCEPT',
  Pending = 'PENDING',
  Reject = 'REJECT'
}

export type NotificationInput = {
  attachments?: InputMaybe<Array<NotificationAttachmentInput>>;
  message: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['Map']['input']>;
  retailerID: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
  type: NotificationType;
};

export type NotificationResolveInput = {
  status: NotificationResponseStatus;
};

export enum NotificationResponseStatus {
  Accept = 'ACCEPT',
  Pending = 'PENDING',
  Reject = 'REJECT'
}

export type NotificationSortInput = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export enum NotificationType {
  Accept = 'ACCEPT'
}

export type NotificationsConnection = {
  __typename?: 'NotificationsConnection';
  edges: Array<NotificationEdge>;
  pageInfo: PageInfo;
};

export type Operator = {
  __typename?: 'Operator';
  alias?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  erpId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
};

export type OperatorInput = {
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OperatorNumberInput = {
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Order = {
  __typename?: 'Order';
  billingAddress?: Maybe<OrderAddress>;
  checkoutURL?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  confirmedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByUser?: Maybe<User>;
  currency: Currency;
  customer?: Maybe<Customer>;
  customerID?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deliveries: Array<Delivery>;
  documents: Array<Document>;
  id: Scalars['ID']['output'];
  invoices: Array<Invoice>;
  lineItems: Array<OrderLineItem>;
  orderTotalGross?: Maybe<Scalars['Float']['output']>;
  orderTotalTax?: Maybe<Scalars['Float']['output']>;
  outstandingAmount?: Maybe<Scalars['Float']['output']>;
  paymentStatus?: Maybe<MolliePaymentStatus>;
  retailer?: Maybe<Retailer>;
  retailerCustomerID?: Maybe<Scalars['UUID']['output']>;
  retailerID?: Maybe<Scalars['ID']['output']>;
  retailerOrderID?: Maybe<Scalars['String']['output']>;
  status: OrderStatus;
  totalNet?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['String']['output'];
  user?: Maybe<User>;
  userID?: Maybe<Scalars['UUID']['output']>;
};


export type OrderLineItemsArgs = {
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};

export type OrderAddress = {
  __typename?: 'OrderAddress';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLocality?: Maybe<Scalars['String']['output']>;
  addressPostcode?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type OrderAddressInput = {
  addressDistrict?: InputMaybe<Scalars['String']['input']>;
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressLocality: Scalars['String']['input'];
  addressPostcode: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type OrderDataInput = {
  billingAddress?: InputMaybe<OrderAddressInput>;
  currency: Currency;
  deliveries: Array<OrderDeliveryInput>;
  totalNet?: InputMaybe<Scalars['Float']['input']>;
};

export type OrderDecline = {
  __typename?: 'OrderDecline';
  articleId: Scalars['ID']['output'];
  articleName: Scalars['String']['output'];
  customerFamilyName: Scalars['String']['output'];
  customerGivenName?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['ID']['output'];
  erpCustomerId: Scalars['String']['output'];
  month: Scalars['Int64']['output'];
  quantityLast12Months?: Maybe<Scalars['Float']['output']>;
  quantityPrevious12Months: Scalars['Float']['output'];
  relativeChange?: Maybe<Scalars['Float']['output']>;
  retailerId: Scalars['ID']['output'];
  taxonomyId: Scalars['ID']['output'];
  taxonomyName: Scalars['String']['output'];
  year?: Maybe<Scalars['Int64']['output']>;
};

export type OrderDeclineSearchFilter = {
  articleIds: Array<Scalars['ID']['input']>;
  deviation: Scalars['Int64']['input'];
  endDate: ComparisonDateFilter;
  erpCustomerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerIds: Array<Scalars['ID']['input']>;
  startDate: ComparisonDateFilter;
  taxonomyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type OrderDeliveriesConnection = {
  __typename?: 'OrderDeliveriesConnection';
  edges: Array<OrderDeliveryEdge>;
  pageInfo: PageInfo;
};

export type OrderDeliveryEdge = {
  __typename?: 'OrderDeliveryEdge';
  cursor: Scalars['ID']['output'];
  nextCursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<Delivery>;
};

export type OrderDeliveryInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<OrderAddressInput>;
  deliveryFrom?: InputMaybe<Scalars['String']['input']>;
  deliveryTime?: InputMaybe<Scalars['String']['input']>;
  deliveryTo?: InputMaybe<Scalars['String']['input']>;
  items: Array<OrderLineItemInput>;
  locationID?: InputMaybe<Scalars['ID']['input']>;
  siloID?: InputMaybe<Scalars['ID']['input']>;
  type: DeliveryType;
};

export type OrderEdge = {
  __typename?: 'OrderEdge';
  cursor: Scalars['ID']['output'];
  nextCursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<Order>;
};

export type OrderFilterInput = {
  completedAt?: InputMaybe<DateFilterInput>;
  confirmedAt?: InputMaybe<Array<OperatorInput>>;
  createdAt?: InputMaybe<DateFilterInput>;
  deletedAt?: InputMaybe<DateFilterInput>;
  retailerID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Array<OrderStatus>>;
  updatedAt?: InputMaybe<DateFilterInput>;
};

export type OrderLineEdge = {
  __typename?: 'OrderLineEdge';
  cursor: Scalars['ID']['output'];
  nextCursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<OrderLineItem>;
};

export type OrderLineFilterInput = {
  catalogueID?: InputMaybe<Array<Scalars['ID']['input']>>;
  confirmedAt?: InputMaybe<Array<OperatorInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  retailerID?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type OrderLineItem = {
  __typename?: 'OrderLineItem';
  amount?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  delivery?: Maybe<Delivery>;
  deliveryID?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  inventory?: Maybe<Inventory>;
  inventoryID?: Maybe<Scalars['ID']['output']>;
  lineTotalGross?: Maybe<Scalars['Float']['output']>;
  lineTotalNet?: Maybe<Scalars['Float']['output']>;
  lineTotalQuantity?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order: Order;
  orderID: Scalars['ID']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  retailerID: Scalars['ID']['output'];
  taxRate?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type OrderLineItemInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  catalogueID: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  inventoryID: Scalars['ID']['input'];
  lineTotalGross?: InputMaybe<Scalars['Float']['input']>;
  lineTotalNet?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type OrderLinesConnection = {
  __typename?: 'OrderLinesConnection';
  edges: Array<OrderLineEdge>;
  pageInfo: PageInfo;
};

export type OrderNotification = {
  __typename?: 'OrderNotification';
  averageAmountMonth: Scalars['Float']['output'];
  averageRhythm: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  currentMonthOrderQuantity: Scalars['Float']['output'];
  customerFamilyName: Scalars['String']['output'];
  customerGivenName?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['ID']['output'];
  daysSinceLastOrder: Scalars['Float']['output'];
  deviationFlagQuant: Scalars['Boolean']['output'];
  deviationFlagTime: Scalars['Boolean']['output'];
  erpCustomerId: Scalars['String']['output'];
  expectedNextOrderDate: Scalars['String']['output'];
  lastInvoiceDate: Scalars['String']['output'];
  lastOrderDate: Scalars['String']['output'];
  retailerId: Scalars['ID']['output'];
  taxonomyId: Scalars['ID']['output'];
  taxonomyName: Scalars['String']['output'];
};

export type OrderNotificationSearchFilter = {
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  erpCustomerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  taxonomyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type OrderSortInput = {
  completedAt?: InputMaybe<Sort>;
  confirmedAt?: InputMaybe<Sort>;
  createdAt?: InputMaybe<Sort>;
  status?: InputMaybe<Sort>;
  totalGross?: InputMaybe<Sort>;
  totalNet?: InputMaybe<Sort>;
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING'
}

export type OrdersConnection = {
  __typename?: 'OrdersConnection';
  edges: Array<OrderEdge>;
  pageInfo: PageInfo;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['ID']['output'];
  startCursor: Scalars['ID']['output'];
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaymentInvoice = {
  __typename?: 'PaymentInvoice';
  checkoutUrl: Scalars['String']['output'];
  invoiceID: Scalars['ID']['output'];
  retailerID: Scalars['ID']['output'];
};

export type PaymentOption = {
  __typename?: 'PaymentOption';
  fee: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  provider: Scalars['String']['output'];
};

export type Point = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
};

export type PolicyInput = {
  dataProtection?: InputMaybe<Scalars['String']['input']>;
  imprint?: InputMaybe<Scalars['String']['input']>;
  msds?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['String']['input']>;
};

export enum PreferredPriceType {
  Base = 'base',
  HighDiscount = 'high_discount',
  LowDiscount = 'low_discount'
}

export type PriceTables = {
  __typename?: 'PriceTables';
  default?: Maybe<Scalars['Int64']['output']>;
  mapping?: Maybe<Scalars['Map']['output']>;
};

export type QuantityOptions = {
  __typename?: 'QuantityOptions';
  default?: Maybe<Scalars['String']['output']>;
  delivery?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pickup?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  post?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Query = {
  __typename?: 'Query';
  article?: Maybe<Article>;
  articles: Array<Article>;
  articlesConnection: ArticlesConnection;
  currentUser?: Maybe<User>;
  customerSales?: Maybe<Array<CustomerSales>>;
  findCustomerArticles?: Maybe<Array<CustomerArticle>>;
  getDatasheetURL: Scalars['String']['output'];
  inventory: Inventory;
  jobConnection: JobConnection;
  livePrices: Array<Maybe<LivePrice>>;
  mollieConfig?: Maybe<MollieConfig>;
  notifications: Array<Notification>;
  orderDeclines?: Maybe<Array<OrderDecline>>;
  orderLines: Array<OrderLineItem>;
  orderNotifications?: Maybe<Array<OrderNotification>>;
  orders: Array<Order>;
  ordersTotal: Scalars['Int64']['output'];
  organization?: Maybe<MollieOrganization>;
  retailer: Retailer;
  retailers: Array<Maybe<Retailer>>;
  salesComparison?: Maybe<Array<SalesComparison>>;
  silo: Silo;
  silos: Array<Silo>;
  taxonomy?: Maybe<Taxonomy>;
  taxonomyTree: Array<Maybe<Taxonomy>>;
};


export type QueryArticleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryArticlesArgs = {
  articleSearch?: InputMaybe<ArticleSearchInput>;
  inventorySearch?: InputMaybe<InventorySearch>;
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type QueryArticlesConnectionArgs = {
  after: Scalars['ID']['input'];
  articleSearch?: InputMaybe<ArticleSearchInput>;
  first?: Scalars['Int']['input'];
  inventorySearch?: InputMaybe<InventorySearch>;
};


export type QueryCustomerSalesArgs = {
  filter: CustomerSalesSearchFilter;
};


export type QueryFindCustomerArticlesArgs = {
  filter: FindCustomerArticleFilter;
};


export type QueryGetDatasheetUrlArgs = {
  inventoryID: Scalars['ID']['input'];
};


export type QueryInventoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<JobFilterInput>;
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<JobSortInput>;
};


export type QueryLivePricesArgs = {
  in?: InputMaybe<LivePriceInput>;
};


export type QueryNotificationsArgs = {
  filter?: InputMaybe<NotificationFilterInput>;
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type QueryOrderDeclinesArgs = {
  filter: OrderDeclineSearchFilter;
};


export type QueryOrderLinesArgs = {
  catalogueId: Scalars['ID']['input'];
};


export type QueryOrderNotificationsArgs = {
  filter: OrderNotificationSearchFilter;
};


export type QueryOrdersArgs = {
  filter?: InputMaybe<OrderFilterInput>;
};


export type QueryOrdersTotalArgs = {
  filter?: InputMaybe<OrderFilterInput>;
};


export type QueryOrganizationArgs = {
  retailerId: Scalars['ID']['input'];
};


export type QueryRetailerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRetailersArgs = {
  search?: InputMaybe<SearchRetailerFilter>;
};


export type QuerySalesComparisonArgs = {
  filter: SalesComparisonSearchFilter;
};


export type QuerySiloArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaxonomyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaxonomyTreeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RemoveInventoriesByFilter = {
  articleID?: InputMaybe<Scalars['ID']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  retailerID: Scalars['ID']['input'];
};

export type Retailer = {
  __typename?: 'Retailer';
  acceptOrders: AcceptOrderMode;
  colour?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  contractsConnection?: Maybe<ContractConnection>;
  creditNotesConnection?: Maybe<CreditNotesConnection>;
  cropDeliveryNotesConnection?: Maybe<CropDeliveryNotesConnection>;
  customer?: Maybe<Customer>;
  customerByEmail: Array<Customer>;
  customerByPhoneNumber: Array<Customer>;
  customerByRetailerCustomerID?: Maybe<Customer>;
  customerNotes: Array<CustomerNote>;
  customers: Array<Customer>;
  customersByGroup: Array<Customer>;
  customersConnection: CustomersConnection;
  customersForNotificationGroup: Array<Customer>;
  customersPrice?: Maybe<Array<CustomerPrice>>;
  dataProtection?: Maybe<Scalars['String']['output']>;
  deliveries: Array<Delivery>;
  deliveryArea: Coordinates;
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<Document>;
  documentsConnection: DocumentsConnection;
  groups: Array<CustomerGroup>;
  id: Scalars['ID']['output'];
  imprint?: Maybe<Scalars['String']['output']>;
  inventory?: Maybe<Array<Inventory>>;
  inventoryConnection: InventoryConnection;
  invoice: Invoice;
  invoiceLinesConnection: InvoiceLinesConnection;
  invoices: Array<Maybe<Invoice>>;
  invoicesConnection: InvoicesConnection;
  lineItems: Array<OrderLineItem>;
  locations: Array<Location>;
  logo?: Maybe<Scalars['String']['output']>;
  msds?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notificationGroup: NotificationGroup;
  notificationGroupMessages: Array<NotificationGroupMessage>;
  notificationGroups: Array<NotificationGroup>;
  notificationsConnection?: Maybe<NotificationsConnection>;
  operators?: Maybe<Array<Operator>>;
  order?: Maybe<Order>;
  orderDeliveriesConnection: OrderDeliveriesConnection;
  orderLinesConnection: OrderLinesConnection;
  orders?: Maybe<Array<Order>>;
  ordersConnection: OrdersConnection;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  retailerRoles: Array<Maybe<UserScoped>>;
  salesDeliveryNote: SalesDeliveryNote;
  salesDeliveryNotesConnection?: Maybe<SalesDeliveryNotesConnection>;
  salesDeliveryNotesLineItemsConnection?: Maybe<SalesDeliveryNoteLineItemsConnection>;
  settings: RetailerSettings;
  silo?: Maybe<Silo>;
  silos: Array<Maybe<Silo>>;
  storeDiscoverability: DiscoverabilityMode;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};


export type RetailerContractArgs = {
  id: Scalars['ID']['input'];
};


export type RetailerContractsConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<ContractFilterInput>;
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<ContractSortInput>;
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type RetailerCreditNotesConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<CreditNotesFilterInput>;
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<CreditNotesSortInput>;
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type RetailerCropDeliveryNotesConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<CropDeliveryNoteFilterInput>;
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<CropDeliveryNotesSortInput>;
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type RetailerCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type RetailerCustomerByEmailArgs = {
  email: Scalars['String']['input'];
};


export type RetailerCustomerByPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type RetailerCustomerByRetailerCustomerIdArgs = {
  id: Scalars['String']['input'];
};


export type RetailerCustomerNotesArgs = {
  timeFilter?: InputMaybe<Array<InputMaybe<TimeFilterInput>>>;
};


export type RetailerCustomersArgs = {
  filter?: InputMaybe<CustomerFilter>;
  timeFilter?: InputMaybe<Array<InputMaybe<TimeFilterInput>>>;
};


export type RetailerCustomersByGroupArgs = {
  groupId: Scalars['ID']['input'];
};


export type RetailerCustomersConnectionArgs = {
  after?: Scalars['ID']['input'];
  filter?: InputMaybe<CustomerFilter>;
  first?: Scalars['Int']['input'];
};


export type RetailerCustomersForNotificationGroupArgs = {
  filter?: InputMaybe<CustomerFilter>;
};


export type RetailerDocumentsConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<DocumentFilterInput>;
  first?: Scalars['Int']['input'];
  timeFilter?: InputMaybe<Array<InputMaybe<TimeFilterInput>>>;
};


export type RetailerInventoryArgs = {
  searchFilter?: InputMaybe<SearchFilter>;
  timeFilter?: InputMaybe<Array<InputMaybe<TimeFilterInput>>>;
};


export type RetailerInventoryConnectionArgs = {
  after?: Scalars['ID']['input'];
  first?: Scalars['Int']['input'];
  searchFilter: SearchFilter;
};


export type RetailerInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type RetailerInvoiceLinesConnectionArgs = {
  after: Scalars['ID']['input'];
  first?: Scalars['Int']['input'];
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type RetailerInvoicesArgs = {
  timeFilter?: InputMaybe<Array<InputMaybe<TimeFilterInput>>>;
};


export type RetailerInvoicesConnectionArgs = {
  after: Scalars['ID']['input'];
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<InvoicesConnectionSortInput>;
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type RetailerLocationsArgs = {
  locationFilter?: InputMaybe<LocationFilter>;
};


export type RetailerNotificationGroupArgs = {
  id: Scalars['ID']['input'];
};


export type RetailerNotificationGroupMessagesArgs = {
  timeFilter?: InputMaybe<Array<InputMaybe<TimeFilterInput>>>;
};


export type RetailerNotificationGroupsArgs = {
  timeFilter?: InputMaybe<Array<InputMaybe<TimeFilterInput>>>;
};


export type RetailerNotificationsConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<NotificationFilterInput>;
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<NotificationSortInput>;
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type RetailerOrderArgs = {
  id: Scalars['ID']['input'];
};


export type RetailerOrderDeliveriesConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<DeliveryFilterInput>;
  first?: Scalars['Int']['input'];
  timeFilter?: InputMaybe<Array<InputMaybe<TimeFilterInput>>>;
};


export type RetailerOrderLinesConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<OrderLineFilterInput>;
  first?: Scalars['Int']['input'];
  timeFilter?: InputMaybe<Array<InputMaybe<TimeFilterInput>>>;
};


export type RetailerOrdersArgs = {
  filter?: InputMaybe<OrderFilterInput>;
  timeFilter?: InputMaybe<Array<InputMaybe<TimeFilterInput>>>;
};


export type RetailerOrdersConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<OrderFilterInput>;
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<OrderSortInput>;
  timeFilter?: InputMaybe<Array<InputMaybe<TimeFilterInput>>>;
};


export type RetailerSalesDeliveryNoteArgs = {
  id: Scalars['ID']['input'];
};


export type RetailerSalesDeliveryNotesConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<SalesDeliveryNoteFilterInput>;
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<SalesDeliveryNotesSortInput>;
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type RetailerSalesDeliveryNotesLineItemsConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<SalesDeliveryNoteLineItemFilterInput>;
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<SalesDeliveryNotesLineItemsSortInput>;
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type RetailerSiloArgs = {
  customerID: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type RetailerSilosArgs = {
  customerID: Scalars['ID']['input'];
};

export type RetailerBasePrice = {
  __typename?: 'RetailerBasePrice';
  amount: Scalars['Float']['output'];
  factor: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
};

export type RetailerNoteInput = {
  message: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export enum RetailerRole {
  Admin = 'ADMIN',
  Customer = 'CUSTOMER',
  Owner = 'OWNER',
  Representative = 'REPRESENTATIVE'
}

export type RetailerScoped = {
  __typename?: 'RetailerScoped';
  retailer?: Maybe<Retailer>;
  roles: Array<RetailerRole>;
};

export type RetailerSettings = {
  __typename?: 'RetailerSettings';
  customTheme: Scalars['Boolean']['output'];
  customerNoteTitles: Array<Scalars['String']['output']>;
  enableAnalytics: Scalars['Boolean']['output'];
  erpType: Scalars['String']['output'];
  hideContracts: Scalars['Boolean']['output'];
  hideCropDeliveryNotes: Scalars['Boolean']['output'];
  hideInvoices: Scalars['Boolean']['output'];
  hidePrices: Scalars['Boolean']['output'];
  hideSalesDeliveryNotes: Scalars['Boolean']['output'];
  hideVolumeDiscounts: Scalars['Boolean']['output'];
  livePriceErpType?: Maybe<ErpType>;
  paymentsMinAmount: Scalars['Int64']['output'];
  populateCommentsForReordering: Scalars['Boolean']['output'];
  preferredPriceType: PreferredPriceType;
  priceTables?: Maybe<PriceTables>;
  reorderArticles: Scalars['Boolean']['output'];
  requiredDeliveryDate: Scalars['Boolean']['output'];
  requiredDeliveryTime: Scalars['Boolean']['output'];
  retailerID: Scalars['ID']['output'];
  skipPriceValidation: Scalars['Boolean']['output'];
  useActiveLocationsOnly: Scalars['Boolean']['output'];
  useAddrMultiSelect: Scalars['Boolean']['output'];
  useArtTxtInOrder: Scalars['Boolean']['output'];
  useBasePrice: Scalars['Boolean']['output'];
  useContractApprovalFlow: Scalars['Boolean']['output'];
  useCustomerNoteTitle: Scalars['Boolean']['output'];
  usePayments: Scalars['Boolean']['output'];
};

export type RetailerSettingsInput = {
  customTheme?: InputMaybe<Scalars['Boolean']['input']>;
  customerNoteTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  enableAnalytics?: InputMaybe<Scalars['Boolean']['input']>;
  erpType?: InputMaybe<Scalars['String']['input']>;
  hideContracts?: InputMaybe<Scalars['Boolean']['input']>;
  hideCropDeliveryNotes?: InputMaybe<Scalars['Boolean']['input']>;
  hideInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  hidePrices?: InputMaybe<Scalars['Boolean']['input']>;
  hideSalesDeliveryNotes?: InputMaybe<Scalars['Boolean']['input']>;
  hideVolumeDiscounts?: InputMaybe<Scalars['Boolean']['input']>;
  livePriceErpType?: InputMaybe<Scalars['String']['input']>;
  paymentsMaxAmount?: InputMaybe<Scalars['Int64']['input']>;
  paymentsMinAmount?: InputMaybe<Scalars['Int64']['input']>;
  populateCommentsForReordering?: InputMaybe<Scalars['Boolean']['input']>;
  preferredPriceType?: InputMaybe<PreferredPriceType>;
  reorderArticles?: InputMaybe<Scalars['Boolean']['input']>;
  requiredDeliveryDate?: InputMaybe<Scalars['Boolean']['input']>;
  requiredDeliveryTime?: InputMaybe<Scalars['Boolean']['input']>;
  skipPriceValidation?: InputMaybe<Scalars['Boolean']['input']>;
  useActiveLocationsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  useAddrMultiSelect?: InputMaybe<Scalars['Boolean']['input']>;
  useArtTxtInOrder?: InputMaybe<Scalars['Boolean']['input']>;
  useBasePrice?: InputMaybe<Scalars['Boolean']['input']>;
  useContractApprovalFlow?: InputMaybe<Scalars['Boolean']['input']>;
  useCustomerNoteTitle?: InputMaybe<Scalars['Boolean']['input']>;
  usePayments?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum RoleOption {
  Admin = 'ADMIN',
  CheckPrice = 'CHECK_PRICE',
  Customer = 'CUSTOMER',
  Owner = 'OWNER',
  Representative = 'REPRESENTATIVE',
  Self = 'SELF'
}

export type SalesComparison = {
  __typename?: 'SalesComparison';
  articleId: Scalars['ID']['output'];
  articleName: Scalars['String']['output'];
  customerFamilyName: Scalars['String']['output'];
  customerGivenName?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  erpCustomerId: Scalars['String']['output'];
  historicalAverageQuantity: Scalars['Float']['output'];
  historicalAverageRevenue: Scalars['Float']['output'];
  month: Scalars['Int64']['output'];
  quantityMonth: Scalars['Float']['output'];
  retailerId: Scalars['ID']['output'];
  revenueMonth: Scalars['Float']['output'];
  taxonomyId: Scalars['ID']['output'];
  taxonomyName: Scalars['String']['output'];
  year: Scalars['Int64']['output'];
};

export type SalesComparisonSearchFilter = {
  articleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  compareEndDate: ComparisonDateFilter;
  compareStartDate: ComparisonDateFilter;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate: ComparisonDateFilter;
  erpCustomerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: ComparisonDateFilter;
  taxonomyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SalesDeliveryNote = {
  __typename?: 'SalesDeliveryNote';
  createdAt: Scalars['String']['output'];
  customer?: Maybe<Customer>;
  customerID: Scalars['ID']['output'];
  date: Scalars['String']['output'];
  delivered: Scalars['Boolean']['output'];
  deliveryAddress?: Maybe<OrderAddress>;
  erpCustomerID: Scalars['String']['output'];
  erpNoteID: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lineItems: Array<SalesDeliveryNoteLineItem>;
  operator?: Maybe<Scalars['String']['output']>;
  printed: Scalars['Boolean']['output'];
  retailerID: Scalars['ID']['output'];
  signature?: Maybe<SignatureAttachment>;
  signatureAttachmentID?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['String']['output'];
  user?: Maybe<User>;
  userID?: Maybe<Scalars['UUID']['output']>;
};

export type SalesDeliveryNoteEdge = {
  __typename?: 'SalesDeliveryNoteEdge';
  cursor: Scalars['ID']['output'];
  nextCursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<SalesDeliveryNote>;
};

export type SalesDeliveryNoteFilterInput = {
  customerID?: InputMaybe<Array<Scalars['ID']['input']>>;
  date?: InputMaybe<Array<DateFilterInput>>;
  delivered?: InputMaybe<Scalars['Boolean']['input']>;
  printed?: InputMaybe<Scalars['Boolean']['input']>;
  retailerID?: InputMaybe<Scalars['ID']['input']>;
};

export type SalesDeliveryNoteLineItem = {
  __typename?: 'SalesDeliveryNoteLineItem';
  amount: Scalars['Float']['output'];
  catalogueID?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  date: Scalars['String']['output'];
  erpArticleID?: Maybe<Scalars['String']['output']>;
  erpItemID: Scalars['String']['output'];
  erpNoteID: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inventory?: Maybe<Inventory>;
  inventoryID?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  noteID: Scalars['ID']['output'];
  retailerID: Scalars['ID']['output'];
  unit: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type SalesDeliveryNoteLineItemEdge = {
  __typename?: 'SalesDeliveryNoteLineItemEdge';
  cursor: Scalars['ID']['output'];
  nextCursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<SalesDeliveryNoteLineItem>;
};

export type SalesDeliveryNoteLineItemFilterInput = {
  customerID?: InputMaybe<Scalars['ID']['input']>;
  retailerID?: InputMaybe<Scalars['ID']['input']>;
};

export type SalesDeliveryNoteLineItemsConnection = {
  __typename?: 'SalesDeliveryNoteLineItemsConnection';
  edges: Array<SalesDeliveryNoteLineItemEdge>;
  pageInfo: PageInfo;
};

export type SalesDeliveryNotesConnection = {
  __typename?: 'SalesDeliveryNotesConnection';
  edges: Array<SalesDeliveryNoteEdge>;
  pageInfo: PageInfo;
};

export type SalesDeliveryNotesLineItemsSortInput = {
  createdAt?: InputMaybe<Sort>;
  date?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type SalesDeliveryNotesSortInput = {
  createdAt?: InputMaybe<Sort>;
  date?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type SearchFilter = {
  activeState?: InputMaybe<Scalars['String']['input']>;
  article_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasArticleID?: InputMaybe<Scalars['Boolean']['input']>;
  isInStock?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type SearchRetailerFilter = {
  isCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  isDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Point>;
  range?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceErpSyncJobInput = {
  retailerID: Scalars['ID']['input'];
};

export type SignatureAttachment = {
  __typename?: 'SignatureAttachment';
  filename: Scalars['String']['output'];
  key: Scalars['String']['output'];
  mime: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type Silo = {
  __typename?: 'Silo';
  address?: Maybe<Address>;
  addressID?: Maybe<Scalars['ID']['output']>;
  capacity: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  currentProduce: Scalars['String']['output'];
  customerID?: Maybe<Scalars['ID']['output']>;
  description: Scalars['String']['output'];
  freeCapacity: Scalars['Float']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  retailerID?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['String']['output'];
  user?: Maybe<User>;
  userID?: Maybe<Scalars['UUID']['output']>;
};

export type SiloCreateInput = {
  addressID?: InputMaybe<Scalars['ID']['input']>;
  capacity: Scalars['Float']['input'];
  currentProduce: Scalars['String']['input'];
  customerID?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  freeCapacity: Scalars['Float']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  retailerID?: InputMaybe<Scalars['ID']['input']>;
};

export type SiloUpdateInput = {
  addressID?: InputMaybe<Scalars['ID']['input']>;
  capacity: Scalars['Float']['input'];
  currentProduce: Scalars['String']['input'];
  customerID?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  freeCapacity: Scalars['Float']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  retailerID?: InputMaybe<Scalars['ID']['input']>;
};

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Taxonomy = {
  __typename?: 'Taxonomy';
  articles: Array<Maybe<Article>>;
  children: Array<Taxonomy>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type TimeFilterInput = {
  createdAt?: InputMaybe<OperatorInput>;
  deletedAt?: InputMaybe<OperatorInput>;
  updatedAt?: InputMaybe<OperatorInput>;
};

export type TimeFrame = {
  __typename?: 'TimeFrame';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type TimeFrameInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export enum UploadPrefix {
  NotificationGroupMessage = 'NotificationGroupMessage',
  Signature = 'Signature'
}

export type UploadUrlInfo = {
  __typename?: 'UploadUrlInfo';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  addresses: Array<Address>;
  contract: Contract;
  contractsConnection: ContractConnection;
  creditNotesConnection?: Maybe<CreditNotesConnection>;
  cropDeliveryNotesConnection?: Maybe<CropDeliveryNotesConnection>;
  documents: Array<Document>;
  email?: Maybe<Scalars['String']['output']>;
  emailMarketing: Scalars['Boolean']['output'];
  erpCustomerGroupId?: Maybe<Scalars['String']['output']>;
  erpCustomerId?: Maybe<Scalars['String']['output']>;
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  invoice: Invoice;
  /** @deprecated deprecated in favor of paginated resolver */
  invoices: Array<Maybe<Invoice>>;
  invoicesConnection: InvoicesConnection;
  language: Scalars['String']['output'];
  lineItems: Array<OrderLineItem>;
  lineItemsConnection: OrderLinesConnection;
  notificationsConnection: NotificationsConnection;
  order?: Maybe<Order>;
  orders: Array<Order>;
  ordersConnection: OrdersConnection;
  phoneNumber: Scalars['String']['output'];
  prices?: Maybe<Array<CustomerPrice>>;
  primaryAddress?: Maybe<Address>;
  primaryAddressId?: Maybe<Scalars['ID']['output']>;
  retailerRole?: Maybe<RetailerScoped>;
  retailerRoles: Array<RetailerScoped>;
  salesDeliveryNote: SalesDeliveryNote;
  salesDeliveryNotesConnection?: Maybe<SalesDeliveryNotesConnection>;
  salesDeliveryNotesLineItemsConnection?: Maybe<SalesDeliveryNoteLineItemsConnection>;
  silo: Silo;
  silos: Array<Silo>;
  syncFile?: Maybe<Blob>;
};


export type UserContractArgs = {
  id: Scalars['ID']['input'];
};


export type UserContractsConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<ContractFilterInput>;
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<ContractSortInput>;
};


export type UserCreditNotesConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<CreditNotesFilterInput>;
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<CreditNotesSortInput>;
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type UserCropDeliveryNotesConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<CropDeliveryNoteFilterInput>;
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<CropDeliveryNotesSortInput>;
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type UserDocumentsArgs = {
  filter?: InputMaybe<DocumentFilterInput>;
};


export type UserInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type UserInvoicesConnectionArgs = {
  after: Scalars['ID']['input'];
  filter: InvoicesConnectionInput;
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<InvoicesConnectionSortInput>;
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type UserLineItemsArgs = {
  filter?: InputMaybe<OrderLineFilterInput>;
};


export type UserLineItemsConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<OrderLineFilterInput>;
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<LineItemSortInput>;
  timefilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type UserNotificationsConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<NotificationFilterInput>;
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<NotificationSortInput>;
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type UserOrderArgs = {
  id: Scalars['ID']['input'];
};


export type UserOrdersArgs = {
  filter?: InputMaybe<OrderFilterInput>;
};


export type UserOrdersConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<OrderFilterInput>;
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<OrderSortInput>;
  timeFilter?: InputMaybe<Array<InputMaybe<TimeFilterInput>>>;
};


export type UserPricesArgs = {
  retailer: Scalars['ID']['input'];
};


export type UserRetailerRoleArgs = {
  retailer: Scalars['ID']['input'];
};


export type UserSalesDeliveryNoteArgs = {
  id: Scalars['ID']['input'];
};


export type UserSalesDeliveryNotesConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<SalesDeliveryNoteFilterInput>;
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<SalesDeliveryNotesSortInput>;
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type UserSalesDeliveryNotesLineItemsConnectionArgs = {
  after: Scalars['ID']['input'];
  filter?: InputMaybe<SalesDeliveryNoteLineItemFilterInput>;
  first?: Scalars['Int']['input'];
  sort?: InputMaybe<SalesDeliveryNotesLineItemsSortInput>;
  timeFilter?: InputMaybe<Array<TimeFilterInput>>;
};


export type UserSiloArgs = {
  id: Scalars['ID']['input'];
};


export type UserSyncFileArgs = {
  retailerID: Scalars['ID']['input'];
  schemaVersion?: Scalars['Int']['input'];
};

export type UserCreateInput = {
  emailMarketing: Scalars['Boolean']['input'];
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  primaryAddress: AddressInput;
};

export type UserScoped = {
  __typename?: 'UserScoped';
  contractNotificationsEnabled: Scalars['Boolean']['output'];
  operator?: Maybe<Operator>;
  operatorID?: Maybe<Scalars['ID']['output']>;
  orderNotificationsEnabled: Scalars['Boolean']['output'];
  roles: Array<RetailerRole>;
  user?: Maybe<User>;
};

export type UserSession = {
  __typename?: 'UserSession';
  date: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  timestamp: Scalars['String']['output'];
  userID: Scalars['UUID']['output'];
};

export type UserSessionInput = {
  timestamp?: InputMaybe<Scalars['String']['input']>;
};

export type UserUpdateInput = {
  emailMarketing: Scalars['Boolean']['input'];
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type VolumeDiscount = {
  __typename?: 'VolumeDiscount';
  ErpCustomerGroupId?: Maybe<Scalars['ID']['output']>;
  ErpCustomerId?: Maybe<Scalars['String']['output']>;
  basePrice: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  fromQuantity: Scalars['ID']['output'];
  grossBasePrice: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  inventoryId: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  retailerId: Scalars['ID']['output'];
  retailerItemId: Scalars['String']['output'];
  retailerPriceTableId: Scalars['ID']['output'];
  taxRate: Scalars['Float']['output'];
  toQuantity?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['String']['output'];
  validFrom: Scalars['String']['output'];
  validTo?: Maybe<Scalars['String']['output']>;
};

export type VolumeDiscountFilter = {
  erpCustomerGroupId?: InputMaybe<Scalars['ID']['input']>;
  erpCustomerId?: InputMaybe<Scalars['String']['input']>;
};
